import React, { useEffect, useState } from "react";
import { Grid, Typography, Paper, Button, Checkbox } from "@mui/material";
import TextInput from "../../Components/InputComponents/TextInput";
import SelectInput from "../../Components/InputComponents/SelectInput";
import CommonButton from "../../Components/InputComponents/CommonButton";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  errorNotify,
  infoNotify,
  successNotify,
} from "../../Components/ToastComponent/ToastNotification";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

import TextAreaInput from "../../Components/InputComponents/TextAreaInput";
import { decryptId, encryptId } from "../../Components/CryptoComponent";
import { axiosAPI } from "../../Components/AxiosComponents/Axios";

const CreateJobLinking = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  // const decryptedId = decryptId(decodeURIComponent(id));

  const decryptedId = location?.state?.decryptedId;
  const Tab = location?.state?.Tab;

  const [jobdata, setjobdata] = useState({
    job: "",
    interviewDate: "",
    comment: "",
    status: "",
  });

  const [JobList, setJobList] = useState([]);
  const [statusList, setStatusList] = useState([]);

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const mandatoryFields = [
      { field: "job", label: "Job" },
      { field: "status", label: "Status" },
    ];

    let formErrors = {};
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    const phoneRegex = /^[0-9]{10}$/; // 10-digit phone validation

    for (let { field, label, type } of mandatoryFields) {
      const value = jobdata[field];

      if (!value) {
        formErrors[field] = `${label} is required.`;
      } else if (type === "email" && !emailRegex.test(value)) {
        formErrors[field] = `Please enter a valid ${label}.`;
      } else if (type === "phone" && !phoneRegex.test(value)) {
        formErrors[field] = `Please enter a valid ${label}.`;
      }

      if (jobdata.interviewDate == "Invalid Date") {
        formErrors[`interviewDate`] = `Date format is Invalid.`;
      }
    }

    setErrors(formErrors);

    if (Object.keys(formErrors).length > 0) {
      // Display the errors as toast notifications
      Object.values(formErrors).forEach((error) => {
        errorNotify(error);
      });
      return false;
    }

    return true;
  };

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setErrors({
      ...errors,
      [name]: "",
    });

    setjobdata({
      ...jobdata,
      [name]: value,
    });
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      axiosAPI
        ?.post("/Candidate/addCandidateJobLinking", {
          JA_CandidateId: decryptedId,
          JA_JobId: jobdata?.job,
          JA_InterviewDate: jobdata?.interviewDate,
          JA_Comment: jobdata?.comment,
          JA_StatusId: jobdata?.status,
        })
        .then((res) => {
          if (res?.data?.data?.success) {
            successNotify(res?.data?.data?.message);
            const encrypted = encodeURIComponent(encryptId(decryptedId));
            navigate(`/Candidates/View/${encrypted}`, {
              state: { decryptedId: encrypted, Tab: Tab },
            });
          } else {
            infoNotify(res?.data?.data?.message);
          }
        })
        .catch((err) => {
          errorNotify("Something went Wrong!");
        });
    }
  };

  const getJobs = async () => {
    try {
      const res = await axiosAPI.get(`/Job/list`);
      setJobList(res?.data?.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  const getStatus = async () => {
    try {
      const res = await axiosAPI.get(`/JobApplicationStatus/list`);
      setStatusList(res?.data?.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getJobs();
    getStatus();
  }, []);

  return (
    <Paper
      sx={{
        padding: { xs: 2, sm: 3, md: 5 },
        margin: "auto",
        position: "relative",
        fontFamily: "Geist, sans-serif",
        minHeight: "100%",
      }}
    >
      <Typography
        variant="h5"
        sx={{
          fontWeight: 700,
          textAlign: "left",
          marginBottom: 3,
          fontFamily: "Geist, sans-serif",
        }}
      >
        Add Job Linking
      </Typography>

      {/* ============================================================================================================================================================================== */}
      <Grid
        container
        sx={{
          border: "1px solid lightgrey",
          borderRadius: "10px",
          padding: "20px",
        }}
      >
        {/*Job */}
        <Grid item xs={12} sm={6} sx={{ padding: "5px" }}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
          >
            Select a Job <span style={{ color: "red" }}> * </span>
          </Typography>
          <SelectInput
            value={jobdata.job}
            name="job"
            onChange={handleInputChange}
            options={JobList?.map((item) => ({
              value: item?.JD_Id,
              label: `${item?.JD_Title} (${item?.JD_JobId})`,
            }))}
            placeholder="Select a Job"
            error={!!errors?.job}
          />
        </Grid>

        {/* Interview Date */}
        <Grid item xs={12} sm={6} sx={{ padding: "5px" }}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
          >
            Interview Date
          </Typography>
          <TextInput
            label="Interview Date"
            placeholder="Interview Date"
            name="interviewDate"
            value={jobdata.interviewDate}
            onChange={handleInputChange}
            type="date"
            dateRestriction="future"
          />
        </Grid>

        {/* Comment */}
        <Grid item xs={12} sm={12} sx={{ padding: "5px" }}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
          >
            Comment
          </Typography>
          <TextAreaInput
            label="comment"
            placeholder="Enter your Comment"
            name="comment"
            value={jobdata?.comment}
            onChange={handleInputChange}
          />
        </Grid>

        {/* Job Application Status */}
        <Grid item xs={12} sm={6} sx={{ padding: "5px" }}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
          >
            Status <span style={{ color: "red" }}> * </span>
          </Typography>
          <SelectInput
            value={jobdata.status}
            name="status"
            onChange={handleInputChange}
            options={statusList?.map((item) => ({
              value: item?.JASL_Id,
              label: item?.JASL_Name,
            }))}
            placeholder="Select Status"
            error={!!errors?.status}
          />
        </Grid>
      </Grid>

      {/* Buttons */}
      <Grid container spacing={2} justifyContent="flex-end" sx={{ mt: 3 }}>
        <Grid item>
          <CommonButton
            variant="outlined"
            customColor="#B0BEC5"
            onClick={() => {
              const encrypted = encodeURIComponent(encryptId(decryptedId));
              navigate(`/Candidates/View/${encrypted}`,{
              state: { decryptedId: encrypted, Tab: Tab },
            });
            }}
          >
            Cancel
          </CommonButton>
        </Grid>
        <Grid item>
          <CommonButton
            variant="contained"
            customColor="#007BFF"
            onClick={handleSubmit}
          >
            Save
          </CommonButton>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default CreateJobLinking;
